export const boardSummaryTour = {
  key: "boardSummary",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-summary-statcards"]',
      content: t("Tour_BoardSummary_StatCards"),
      placement: "top",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-summary-pipeline"]',
      content: t("Tour_BoardSummary_Progress"),
      placement: "top",
    },
    {
      target: '[data-tour="board-summary-stats"]',
      content: t("Tour_BoardSummary_Members"),
      placement: "top",
    },
    {
      target: '[data-tour="board-summary-activities"]',
      content: t("Tour_BoardSummary_Deadline"),
      placement: "top",
    },
    {
      target: '[data-tour="board-summary-chart"]',
      content: t("Tour_BoardSummary_Medals"),
      placement: "top",
    },
  ],
};
